import { useState } from "react";
import { Sparkle } from "lucide-react";

/**
 * <img> with a graceful fallback: if the URL fails (404, CDN issue),
 * we render a styled placeholder using the planet accent color instead of a broken icon.
 */
export default function ImageWithFallback({
    src,
    alt,
    accentColor = "#C0785E",
    className = "",
    imgClassName = "",
    testid,
}) {
    const [failed, setFailed] = useState(false);

    if (failed || !src) {
        return (
            <div
                className={`relative w-full h-full bg-sand-100 flex items-center justify-center overflow-hidden ${className}`}
                data-testid={testid ? `${testid}-fallback` : undefined}
                aria-label={alt}
            >
                <div className="absolute inset-0" style={{ background: `radial-gradient(circle at 30% 30%, ${accentColor}22, transparent 60%)` }} />
                <Sparkle strokeWidth={1.25} className="w-10 h-10 opacity-70" style={{ color: accentColor }} />
                <span className="absolute bottom-3 left-4 text-[11px] uppercase tracking-[0.2em] text-ink-muted">{alt}</span>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            loading="lazy"
            onError={() => setFailed(true)}
            className={imgClassName || className}
            data-testid={testid}
        />
    );
}
